import { Action, State, types } from '.';
import { ExperianQuestion } from '../../../models/question';
import { WorkflowContext } from 'src/utils/constValues';
import { storeWorkflowContextData, getWorkflowContextData } from 'src/utils/workflow';

export const storeExperianQuestions = (experianQuestions: Array<ExperianQuestion>): Array<ExperianQuestion> => {
    const experianQuestionState = JSON.stringify(experianQuestions);
    if (storeWorkflowContextData(WorkflowContext.EXPERIAN_QUESTIONS.toString(), experianQuestionState)) {
        return experianQuestions;
    }
    return [];
};

export const getExperianQuestions = (): Array<ExperianQuestion> => {
    const experianQuestionState = getWorkflowContextData(WorkflowContext.EXPERIAN_QUESTIONS.toString());
    if (experianQuestionState === '') {
        return [];
    }
    return JSON.parse(experianQuestionState) as Array<ExperianQuestion>;
};

const initialState: State = {
    experianQuestions: getExperianQuestions(),

    submitting: false,
    submitted: false,
    isPass: false,
    errorMessage: ''
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case types.STORE_EXPERIAN_QUESTION_DATA:
            return {
                ...state,
                experianQuestions: storeExperianQuestions(action.experianQuestions)
            };

        case types.SUBMIT_EXPERIAN_ANSWERS_ASYNC:
            return {
                ...state,
                submitting: true,
                submitted: false
            };

        case types.SUBMIT_EXPERIAN_ANSWERS_SUCCEED:
            return {
                ...state,
                submitting: false,
                submitted: true,
                isPass: action.isPass
            };

        case types.SUBMIT_EXPERIAN_ANSWERS_FAILED:
            return {
                ...state,
                submitting: false,
                submitted: false,
                errorMessage: action.errorMessage
            };

        case types.SUBMIT_EXPERIAN_QUESTIONS_ASYNC:
            return {
                ...state,
                submitting: true,
                submitted: false
            };

        case types.SUBMIT_EXPERIAN_QUESTIONS_SUCCEED:
            return {
                ...state,
                submitting: false,
                submitted: true,
                isPass: action.isPass,
            };

        case types.SUBMIT_EXPERIAN_QUESTIONS_FAILED:
            return {
                ...state,
                submitting: false,
                submitted: false,
                errorMessage: action.errorMessage
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/experianQuestion/reducer.ts